export const Placement = Object.freeze({
  TOP: 'top',
  BOTTOM: 'bottom',
  START: 'start',
  END: 'end',
});

export const PopupType = Object.freeze({
  DEFAULT: 'default',
  ALERT: 'alert',
});
